module.exports = __webpack_public_path__ + "img/sharing-bg.70e54eb7.png";